
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:host{
  --sic-card-grid--default--font-size:var(--body-04-font-size);
  --sic-card-grid--default--line-height:var(--body-04-line-height);
  --sic-card-grid--default--layout-gap:var(--grid-gap);
  --sic-card-grid--default--body-spacing:var(--spacing-04);
  --sic-card-grid--default--cta-spacing:var(--spacing-08);
}
`;